const sizes = { xs: 24, sm: 32, md: 40, lg: 56, xl: 80 };

const palette = [
  "var(--navy-700)",
  "var(--ember-700)",
  "var(--sage-600)",
  "var(--ink-800)",
  "var(--crimson-600)",
  "var(--navy-500)",
];

function pick(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % palette.length;
  return palette[h];
}

function initials(name = "") {
  return name.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || "").join("").toUpperCase();
}

export default function Avatar({ name = "", src, size = "md", ring = false, style, ...rest }) {
  const d = sizes[size] || size;
  const wrap = {
    width: d,
    height: d,
    borderRadius: "50%",
    flex: "none",
    overflow: "hidden",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: pick(name),
    color: "var(--sand-75)",
    fontFamily: "var(--font-display)",
    fontWeight: "var(--weight-bold)",
    fontSize: Math.round(d * 0.4),
    boxShadow: ring ? "0 0 0 3px var(--surface-card), 0 0 0 5px var(--brand)" : "none",
    ...style,
  };
  return (
    <span style={wrap} title={name} {...rest}>
      {src ? <img src={src} alt={name} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : initials(name)}
    </span>
  );
}
